const UserEmailValidationStatus = {
  USER_EXISTS_FOR_CURRENT_CLIENT: 'USER_EXISTS_FOR_CURRENT_CLIENT',
  USER_EXISTS_FOR_ANOTHER_CLIENT: 'USER_EXISTS_FOR_ANOTHER_CLIENT',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
};

const INVALID_EMAIL_DEFAULT_MESSAGE = 'Email must be a valid email';

const US_PWC_EMAIL_DOMAIN_SUFFIX = '@us.pwc.com';

const US_PWC_EMAIL_NOT_PERMITTED_MESSAGE =
  'Email addresses ending in @us.pwc.com are not permitted. Please use a different email domain.';

const emailHasBlockedUsPwcDomain = email => {
  if (email == null || typeof email !== 'string') {
    return false;
  }
  return email.trim().toLowerCase().endsWith(US_PWC_EMAIL_DOMAIN_SUFFIX);
};

module.exports = {
  UserEmailValidationStatus,
  INVALID_EMAIL_DEFAULT_MESSAGE,
  US_PWC_EMAIL_NOT_PERMITTED_MESSAGE,
  emailHasBlockedUsPwcDomain,
};
